import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#0B1412]" data-id="element-786" data-mp="3ghc3g4fxp7pa">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-787" data-mp="32lrlbb814tix">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-788" data-mp="36q94p9ah94t6">
          <div className="md:col-span-2" data-id="element-789" data-mp="3ugbqj7nstejc">
            <Link to="/" className="inline-block mb-4" data-id="element-790" data-mp="3ud7czjog16g0">
              {/* Footer uses the green "206" mark directly rather than the shared
                  Logo component, which is a white wordmark intended for the
                  navbar's light/dark inversion. */}
              <img src="https://cdn.magicpatterns.com/uploads/aA6SXGSW4VKGE9XR9GBv1i/206_new_logo_scroll.png" alt="206Gravel" className="h-10 w-auto block" data-id="element-791" data-mp="3qblvtm4vm600" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-792" data-mp="2ezb99xgq7640">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-793" data-mp="3gah0br9yxf4s">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-794" data-mp="3gaz376r4yrlo">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-795" data-mp="3v8rl25k5ns31">
              <li data-id="element-796" data-mp="3q83rbc4jkx54">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-797" data-mp="3q7lmhr3tdall">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-798" data-mp="3474fms9a7yq">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-799" data-mp="34patc8mu2kd">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-800" data-mp="cu0fmmohkl2g">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-801" data-mp="cvtnu6eqzdck">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-802" data-mp="qthxei3d6y2b">
              Products
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-803" data-mp="ms6fkyqqfh4o">
              <li data-id="element-804" data-mp="mptsk764agkr"><Link to="/?category=Base%20%26%20Compaction#materials" className="hover:text-white/70 transition-colors" data-id="element-805" data-mp="mq3fflvv87m8">Base &amp; Compaction</Link></li>
              <li data-id="element-806" data-mp="yv935q2bruu6"><Link to="/?category=Clear%20%26%20Drain#materials" className="hover:text-white/70 transition-colors" data-id="element-807" data-mp="yuzd62ha5noh">Clear &amp; Drain</Link></li>
              <li data-id="element-808" data-mp="13rfyyq10bpye"><Link to="/?category=Soil%2C%20Mulch%20%26%20Org.#materials" className="hover:text-white/70 transition-colors" data-id="element-809" data-mp="18k0qtm0crsza">Soil, Mulch &amp; Org.</Link></li>
              <li data-id="element-810" data-mp="1cl2t6bpkgl5h"><Link to="/?category=Quarry%20Rock#materials" className="hover:text-white/70 transition-colors" data-id="element-811" data-mp="1cl2rm79x4d3d">Quarry Rock</Link></li>
              <li data-id="element-812" data-mp="1hmibvx49ufkp"><Link to="/?category=Landscape%20%26%20Decor#materials" className="hover:text-white/70 transition-colors" data-id="element-813" data-mp="1mjsc87t78bnb">Landscape &amp; Decor</Link></li>
            </ul>
          </div>

          <div data-id="element-814" data-mp="1rgsfkaynz0aq">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-815" data-mp="3ob5681tmoz4l">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-816" data-mp="3t9gfaac3n5lr">
              <li data-id="element-817" data-mp="2aevebtv95q6b">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-818" data-mp="2afdidco5p8os">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-819" data-mp="21mti67s7uw1u">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-820" data-mp="21ma6h8t5t3w9">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-821" data-mp="2tdzo54umbnz1">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-822" data-mp="2tehmq84r6ea4">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-823" data-mp="2kdb9c7xehjl3">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-824" data-mp="2kcrw34ip3jde">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-825" data-mp="2fgkqjcu7o9vz">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-826" data-mp="18xuxp40mfhtd">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-827" data-mp="1414j6l4gsua2">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-828" data-mp="2rvra3mqob2j1">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-829" data-mp="2ivb7efhr7zf8">
          <p data-id="element-830" data-mp="2ntcqv1j3e0r8">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-831" data-mp="3bkrwb3660y6p">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-832" data-mp="3bhvz5h256djb">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-833" data-mp="31mc2gsfr7ati">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-834" data-mp="36mqdmjcnj0vr">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#000000]" data-id="element-835" data-mp="1inea0ix46x8x">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide bg-[#000000]" data-id="element-836" data-mp="1iml9hzor13z8">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[700] text-[#57534e]" data-id="element-837" data-mp="13xgm8433k9k9">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-838" data-mp="zuaaigx7tq6e">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-839" data-mp="18vi8syzqer0h">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-840" data-mp="g7cnob4rn004">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}